import { Tool } from "@/widgets/editor";
import {
	MenuSelectProjectButton,
	MenuDimensionsButton,
	MenuLayersButton,
	MenuRoomMapButton,
	MenuSelectButton,
} from "./MenuButtons";
import type { DrawerButtonContext, EditorToolRailItem } from "./types";

interface ElevationButtonsContext extends DrawerButtonContext {
	tool: Tool;
	showDimensions: boolean;
	showElevationRoomMap: boolean;
	onSelect: () => void;
	onToggleDimensions: () => void;
	onToggleElevationRoomMap: () => void;
	onSelectProject: () => void;
}

/** Кнопки рейки режима развёрток. */
export const elevationButtons = (context: ElevationButtonsContext): EditorToolRailItem[] => {
	if (context.isReadOnly) {
		return [
			MenuLayersButton(context),
			MenuDimensionsButton({
				isEnabled: context.showDimensions,
				onClick: context.onToggleDimensions,
			}),
			MenuSelectProjectButton({
				onClick: context.onSelectProject,
			}),
			MenuRoomMapButton({
				isEnabled: context.showElevationRoomMap,
				onClick: context.onToggleElevationRoomMap,
			}),
		];
	}
	return [
		MenuLayersButton(context),
		MenuSelectButton({
			isEnabled: context.tool === Tool.Select && context.drawer === null,
			onClick: context.onSelect,
		}),
		MenuDimensionsButton({
			isEnabled: context.showDimensions,
			onClick: context.onToggleDimensions,
		}),
		MenuSelectProjectButton({
			onClick: context.onSelectProject,
		}),
		MenuRoomMapButton({
			isEnabled: context.showElevationRoomMap,
			onClick: context.onToggleElevationRoomMap,
		}),
	];
};
